import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ThisWeekForMoms from './components/ThisWeekForMoms';
import WhatThisIs from './components/WhatThisIs';
import ExploreHub from './components/ExploreHub';
import FindYourPeople from './components/FindYourPeople';
import EventsPreview from './components/EventsPreview';
import SocialProof from './components/SocialProof';
import RootedInCommunity from './components/RootedInCommunity';
import FinalCTA from './components/FinalCTA';
import SEO from '../../components/feature/SEO';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'The Mommy Mingle',
      url: siteUrl,
      logo: `${siteUrl}/vite.svg`,
      description:
        'The Mommy Mingle is a community connecting moms across Gwinnett and surrounding counties through events, local finds, trusted recommendations, and real connections.',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Gwinnett County',
        addressRegion: 'GA',
        addressCountry: 'US',
      },
      areaServed: 'Gwinnett County, Georgia and surrounding counties',
      sameAs: ['https://www.facebook.com/groups/themommymingle'],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      url: siteUrl,
      name: 'The Mommy Mingle',
      description: 'Community platform for moms in Gwinnett County, Georgia.',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/events?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="Gwinnett County Mom Community | The Mommy Mingle"
        description="The Mommy Mingle connects moms across Gwinnett and surrounding counties. Discover local events, trusted businesses, and a supportive community — less searching, more living."
        keywords="Gwinnett County moms, mom community Georgia, local events for moms, mama approved businesses, mom meetups Gwinnett"
        canonical="/"
        schema={schema}
      />
      <Navbar />
      <HeroSection />
      <ThisWeekForMoms />
      <WhatThisIs />
      <ExploreHub />
      <FindYourPeople />
      <EventsPreview />
      <SocialProof />
      <RootedInCommunity />
      <FinalCTA />
      <Footer />
    </div>
  );
}
